import { memo } from "react";

type Props = {
	title: string;
	description: string;
};

export const StepHeader = memo(({ title, description }: Props) => {
	return (
		<div className="space-y-0.5">
			<p className="text-gray-500 text-base">{title}</p>
			<h2 className="text-xl font-semibold">{description}</h2>
		</div>
	);
});

StepHeader.displayName = "StepHeader";
